module.exports = __webpack_public_path__ + "static/media/pobble-home-choose-an-image.263ad993.png";